export default class Feedback {
  constructor(name, email, message, phone, address) {
    this.name = name;
    this.email = email;
    this.phone = phone;
    this.message = message;
    this.address = address;
  }
}
